module.exports = __webpack_public_path__ + "static/pioneer-illustration-dd91925fea2b055de6955f139fb46d50.webp";